import useUniqueId from '../utils/useUniqueId';
import { useCopy } from '../utils';
import dictionary from './dictionary';
const joinDefined = array => array.filter(item => item !== undefined).join(' ');
const useInputSupports = _ref => {
  let {
    label,
    feedback,
    validation,
    hint,
    nativeID,
    copy,
    maxCharacterAllowed,
    charactersCount
  } = _ref;
  const getCopy = useCopy({
    dictionary,
    copy
  });
  const hasValidationError = validation === 'error';
  const inputId = useUniqueId('input');
  const hintId = useUniqueId('input-hint');
  const feedbackId = useUniqueId('input-feedback');
  const a11yProps = {
    accessibilityLabel: label,
    accessibilityHint: joinDefined([!hasValidationError && feedback, hint, maxCharacterAllowed ? getCopy('maxCharacters').replace(/%\{charCount\}/g, maxCharacterAllowed) : undefined]),
    // native only -> replaced with describedBy on web
    accessibilityDescribedBy: joinDefined([!hasValidationError && feedback && feedbackId,
    // feedback receives a11yRole=alert on error, so there's no need to include it here
    hint && hintId, charactersCount ? getCopy('charactersRemaining').replace(/%\{charCount\}/g, charactersCount) : undefined]),
    accessibilityInvalid: hasValidationError
  };
  return {
    inputId: nativeID || inputId,
    hintId,
    feedbackId,
    a11yProps
  };
};
export default useInputSupports;